import { ICreateUnidadesBlocoUseCase } from "../../../presentation/useCases/create/create_unidades_bloco_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * CreateUnidadesBlocoUseCase
 */

export class CreateUnidadesBlocoUseCase implements ICreateUnidadesBlocoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }
  async createUnidadesBloco(idBloco: number, andaresQuantidade: number, unidadesQuantidade: number, idAndar: number | null): Promise<void> {
    await this.repository.createUnidadesBloco(idBloco, andaresQuantidade, unidadesQuantidade, idAndar);

  }
}
